import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const MissionPage = lazy(() => import('../pages/mission/page'));
const ServicePage = lazy(() => import('../pages/service/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const SwimmingPage = lazy(() => import('../pages/swimming/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/mission',
    element: <MissionPage />,
  },
  {
    path: '/service',
    element: <ServicePage />,
  },
  {
    path: '/legal',
    element: <LegalPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/swimming',
    element: <SwimmingPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
